export default "__VITE_ASSET__CwTMIx5x__"